import cx from 'classnames'
import { Button } from '@/common'
import { useTranslation } from 'react-i18next'

export default function StepFooter({
  onPrevious,
  onNext,
  isNextEnabled,
  nextLabel,
  previousLabel
}: {
  onPrevious?: () => void
  onNext?: () => void
  isNextEnabled?: boolean
  nextLabel?: string
  previousLabel?: string
}) {
  const { t } = useTranslation()
  return (
    <div
      className={cx('flex', {
        'justify-between': onPrevious && onNext,
        'justify-end': !onPrevious && onNext,
        'justify-start': onPrevious && !onNext
      })}
    >
      {onPrevious && (
        <Button variant="subtle" onClick={onPrevious} className="w-24" disabled={!onPrevious}>
          {previousLabel || t('common:previous')}
        </Button>
      )}
      {onNext && (
        <Button variant="default" onClick={onNext} disabled={!isNextEnabled} className="w-24">
          {nextLabel || t('common:next')}
        </Button>
      )}
    </div>
  )
}
